import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import { CButton } from "@app/components/Common";
import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";

interface IProps {
  closeModal?: () => void;
}

const CrossModalHeader = ({ closeModal }: IProps) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        height: 30,
        marginBottom: 15
      }}
    >
      <Text size={16}>{t("marginMode")}</Text>
      <CButton
        icon={<IconX size={16} color={textw} />}
        style={{
          color: textw,
          padding: 3,
          borderRadius: 50,
        }}
        onClick={() => {
          closeModal && closeModal();
        }}
      />
    </View>
  );
};

export default CrossModalHeader;
